export const experienceData = [
    {
        id: 1,
        company: 'It Computer City',
        jobtitle: 'Computer Science & Application',
        startYear: '2017',
        endYear: '2018'
    },
    {
        id: 2,
        company: 'FNS Club & Institute',
        jobtitle: 'Web Design & development',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 2,
        company: 'Programming Hero',
        jobtitle: 'Front-End Developer(MERN Stack)',
        startYear: '2020',
        endYear: '2021'
    },
    {
        id: 4,
        company: 'Code With Mosh',
        jobtitle: 'Apps Development React-Native (Android & iOS)',
        startYear: '2021',
        endYear: 'Present'
    },
]